import React from 'react'

import { ConfigProvider, theme } from 'antd'

import SiteWrapper from './layout/SiteWrapper'
import Home from './Home'
import './theme.css'

// 🔴 THERE IS NO ANALYTICS CALL HERE ANY MORE — deliberately.
//
// This file used to call `ReactGA.initialize(REACT_APP_MEASUREMENT_ID)` as it rendered, and
// six other files sent `ReactGA.event(...)`. That is a SECOND way into Google that the cookie
// gate cannot see: the gate's promise is that a visit that refuses makes no request to Google
// at all, and a library that initialises at render time breaks that promise whatever the gate
// does.
//
// The gate is now the only thing on this site that may load Google's script, and it sends the
// page views, the clicks and the scroll depth itself. The game's own events go through the
// gate's shim instead, which does not exist until a visitor says yes.
const App = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#a3e635',
          colorBgBase: '#130d04',
          colorBgContainer: '#11161d',
          colorBgElevated: '#18202a',
          colorBorder: 'rgba(255,255,255,0.08)',
          colorText: '#e6edf3',
          colorTextSecondary: '#8b98a5',
          borderRadius: 12
        }
      }}
    >
      {/* min-height rather than height: the page ends with a three-line footer and, on a
          first visit, the cookie question above it. */}
      <div style={{ minHeight: '100vh' }}>
        <SiteWrapper>
          <Home />
        </SiteWrapper>
      </div>
    </ConfigProvider>
  )
}

export default App
